import { WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';

type EarnPageHeadSectionProps = WithClassName;

export function EarnPageHeadSection({ className }: EarnPageHeadSectionProps) {
	return (
		<div
			className={cm(
				'flex w-full flex-col items-center justify-start gap-y-md py-3xl',
				className
			)}
		>
			<h1 className="text-center typo-h3 text-text-default">Drift Earn</h1>

			<p className="w-full text-center typo-b2 text-text-tertiary">
				Your deposits, always growing
			</p>
		</div>
	);
}
